import React, { useState } from 'react'
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
  , Typography
} from '@mui/material'

import { Link, useNavigate } from 'react-router-dom'
/* ICONS */
import {
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  BlurLinearRounded,
  BuildRounded,
  CategoryRounded,
  DataUsageRounded,
  HomeRounded,
  PersonalVideoRounded,
  SettingsRounded,
  ListAlt,
  EventRounded,
  SavedSearchRounded
} from '@mui/icons-material'
import { useLocation } from 'react-router'
import './styles.css'
import useFrontEndConfig from '../../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import NearMeIcon from '@mui/icons-material/NearMe'

import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import useAuthorization from '../../generic/hooks/useAuthorization/useAuthorization'
import useProxiedServicesMenuItems from './useProxiedServicesMenuItems'

const ListItemDisable = (props) => (
  <ListItemButton
    selected={props.selected}
    component={props.component}
    to={props.to}
    disableGutters
    onClick={props.onClick}
    sx={{
      width: '100%',
      maxWidth: 360,
      paddingLeft: theme => theme.spacing(3.5),
      color: '#787874',
      fontSize: '12px'
    }}
  >
    {props.children}
  </ListItemButton>
)

const ListItemNested = (props) => (
  <ListItemButton
    selected={props.selected}
    component={props.component}
    to={props.to}
    disableGutters
    onClick={props.onClick}
    disabled={props.disabled}
    sx={{
      color: '#D1A22E',
      width: '100%',
      maxWidth: 360,
      paddingLeft: theme => theme.spacing(3.5),
      fontSize: '12px'
    }}
  >
    {props.children}
  </ListItemButton>
)

const ListItemNested2 = (props) => (
  <ListItemButton
    selected={props.selected}
    component={props.component}
    to={props.to}
    disableGutters
    onClick={props.onClick}
    disabled={props.disabled}
    sx={{
      width: '100%',
      maxWidth: 360,
      paddingLeft: theme => theme.spacing(4.5),
      fontSize: '12px'
    }}
  >
    {props.children}
  </ListItemButton>
)

const ListItemMain = (props) => (
  <ListItemButton
    selected={props.selected}
    component={props.component}
    to={props.to}
    disableGutters
    onClick={props.onClick}
    disabled={props.disabled}
    sx={{
      paddingLeft: '5px',
      marginTop: 1
    }}
  >
    {props.children}
  </ListItemButton>
)

const MyTypography = (props) => (
  <Typography sx={{
    paddingLeft: '5px',
    fontSize: '14px',
    fontWeight: 500
  }}
  >
    {props.children}
  </Typography>
)

const iconsShadowStyle = {
  maxWidth: 50,
  minWidth: 50,
  fontSize: '28px !important',
  filter: 'drop-shadow(0 0 4px #05fd9265)',
  color: '#80e0a7'
}

// MOS options: permission code -> route. A map (not `/mos/${code.toLowerCase()}`) because a code such as
// DATA_CORRECTION_VIEW does not spell its route (story 202, RN4).
const MOS_ROUTES = {
  RECEPTION: '/mos/reception',
  MANUFACTURING: '/mos/manufacturing',
  DATA_CORRECTION_VIEW: '/mos/dataCorrection'
}

export default function LeftMenu (props) {
  const { url, handleMinimizeDrawer, minimizeDrawer, setHideMenu } = props
  const [openProcess, setOpenProcess] = useState(false)
  const [openMos, setOpenMos] = useState(false)
  const [openResources, setOpenResources] = useState(false)
  const [openDataAnalytics, setOpenDataAnalytics] = useState(false)
  const [openDashboard, setOpenDashboard] = useState(false)
  const [openReport, setOpenReport] = useState(false)
  const [openConfiguration, setOpenConfiguration] = useState(false)
  const [openMaintenance, setOpenMaintenance] = useState(false)
  const [openQuality, setOpenQuality] = useState(false)
  const [currentPage, setCurrenPage] = useState('')
  const [staticConfig] = useFrontEndConfig()
  const isUserAuthorized = useAuthorization()
  const proxiedServiceItems = useProxiedServicesMenuItems()
  const navigate = useNavigate()
  // RN1/RN2 — Product Acceptance (MOD) only exists in the menu when BOTH the client flag
  // (fabricationOrderAcceptanceEnabled, front-end config) AND the FABRICATION_ORDER_ACCEPTANCE
  // permission are present.
  const acceptanceEnabled = !!(staticConfig && staticConfig.fabricationOrderAcceptanceEnabled)

  const handleCloseAllMenus = () => {
    setOpenProcess(false)
    setOpenResources(false)
    setOpenDataAnalytics(false)
    setOpenDashboard(false)
    setOpenReport(false)
    setOpenConfiguration(false)
    setOpenMaintenance(false)
    setOpenMos(false)
    setOpenQuality(false)
  }

  const AutoCollapse = () => {
    const location = useLocation()
    if (location !== null) {
      const path = location.pathname
      if (currentPage !== path) {
        setCurrenPage(path)
        if ((path.includes('/process/') || path.endsWith('/process')) && !path.includes('mos')) {
          if (!openProcess) {
            setOpenProcess(true)
          }
        } else {
          if (openProcess) {
            setOpenProcess(false)
          }
        }
        if (path.includes('/resources/') || path.endsWith('/resources')) {
          if (!openResources) {
            setOpenResources(true)
          }
        } else {
          if (openResources) {
            setOpenResources(false)
          }
        }

        if (path.includes('/dataAnalytics/') || path.endsWith('/dataAnalytics')) {
          if (!openDataAnalytics) {
            setOpenDataAnalytics(true)
          }
        } else if (!path.includes('/reports')) {
          if (openDataAnalytics) {
            setOpenDataAnalytics(false)
          }
        }
        if (path.includes('/dashboard/') || path.endsWith('/dashboard')) {
          if (!openDashboard) {
            setOpenDashboard(true)
          }
        } else {
          if (openDashboard) {
            setOpenDashboard(false)
          }
        }
        if (path.includes('/reports/') || path.endsWith('/reports')) {
          if (!openReport) {
            setOpenReport(true)
          }
        } else {
          if (openReport) {
            setOpenReport(false)
          }
        }
        if (path.includes('/configuration/') || path.endsWith('/configuration')) {
          if (!openConfiguration) {
            setOpenConfiguration(true)
          }
        } else {
          if (openConfiguration) {
            setOpenConfiguration(false)
          }
        }
        if (path.includes('/mos/') || path.endsWith('/mos')) {
          if (!openMos) {
            setOpenMos(true)
          }
        } else {
          if (openMos) {
            setOpenMos(false)
          }
        }
        if (path.includes('/quality/') || path.endsWith('/quality')) {
          if (!openQuality) {
            setOpenQuality(true)
          }
        } else {
          if (openQuality) {
            setOpenQuality(false)
          }
        }
      }
    }
  }

  const { t_ } = useSmartTranslation()

  const licensedModules = Object.keys(MOS_ROUTES).filter((code) => isUserAuthorized(code))

  const handleMosClick = () => {
    if (licensedModules.length === 1) {
      navigate(MOS_ROUTES[licensedModules[0]])
    } else {
      setOpenMos(!openMos)
    }
  }

  return (
    <div id='leftMenu' className='left-menu-container'>
      {AutoCollapse()}
      <List component='nav'>
        <ListItemMain
          selected={url === '/home'}
          button
          component={Link}
          to='/home'
          disableGutters
          disabled={!isUserAuthorized('HOME')}
        >
          <HomeRounded sx={iconsShadowStyle} />
          <MyTypography>{t_('HOME')}</MyTypography>
        </ListItemMain>
        <ListItemMain
          selected={url === '/monitoring'}
          button
          component={Link}
          to='/monitoring'
          disableGutters
          disabled={!isUserAuthorized('MONITORING')}
        >
          <PersonalVideoRounded sx={iconsShadowStyle} />
          <MyTypography>
            {t_('MONITORING')}
          </MyTypography>
        </ListItemMain>
        <ListItemMain
          selected={url === '/planning'}
          button
          component={Link}
          disableGutters
          to='/planning'
          disabled={!isUserAuthorized('PLANNING')}
        >
          <EventRounded sx={iconsShadowStyle} />
          <MyTypography>{t_('PLANNING')}</MyTypography>
        </ListItemMain>
        <ListItemMain
          selected={url === '/orders'}
          button
          component={Link}
          to='/orders'
          disableGutters
          disabled={!isUserAuthorized('ORDERS')}
        >
          <ListAlt sx={iconsShadowStyle} />
          <MyTypography>{t_('ORDERS')}</MyTypography>
        </ListItemMain>

        <ListItemMain
          selected={url === '/process'}
          button
          disableGutters
          disabled={!isUserAuthorized('PROCESS')}
          onClick={() => setOpenProcess(!openProcess)}
        >
          <BlurLinearRounded sx={iconsShadowStyle} />

          <MyTypography>{t_('PROCESS')}</MyTypography>
          {openProcess ? <ArrowDropUp /> : <ArrowDropDown />}
        </ListItemMain>

        <Collapse in={openProcess} timeout='auto' unmountOnExit>
          <ListItemNested
            selected={url === '/process/workflow2'}
            button
            component={Link}
            to='/process/workflow2'
            disableGutters
            disabled={!isUserAuthorized('WORKFLOWS_MANAGER')}
          >
            <MyTypography>{t_('Workflows Manager')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/process/rules'}
            button
            component={Link}
            to='/process/rules'
            disableGutters
            disabled={!isUserAuthorized('RULES_MANAGER')}
          >
            <MyTypography>{t_('Rules Manager')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/process/storage'}
            button
            component={Link}
            to='/process/storage'
            disableGutters
            disabled={!isUserAuthorized('STORAGE')}
          >
            <MyTypography>{t_('Storage')}</MyTypography>
          </ListItemNested>
        </Collapse>

        <ListItemMain
          selected={url === '/resources'}
          button
          onClick={() => setOpenResources(!openResources)}
          disableGutters
          disabled={!isUserAuthorized('RESOURCES')}
        >
          <CategoryRounded sx={iconsShadowStyle} />
          <MyTypography>{t_('RESOURCES')}</MyTypography>
          {openResources ? <ArrowDropUp /> : <ArrowDropDown />}
        </ListItemMain>
        <Collapse in={openResources} timeout='auto' unmountOnExit>
          <ListItemNested
            selected={url === '/resources/reference'}
            button
            component={Link}
            to='/resources/reference'
            disableGutters
            disabled={!isUserAuthorized('PART')}
          >
            <MyTypography>{t_('Part')}</MyTypography>
          </ListItemNested>

          <ListItemNested
            selected={url === '/resources/rawmaterialReference'}
            button
            component={Link}
            to='/resources/rawmaterialReference'
            disableGutters
            disabled={!isUserAuthorized('RAW MATERIAL')}
          >
            <MyTypography>
              {t_('Raw Material')}
            </MyTypography>
          </ListItemNested>

          <ListItemNested
            selected={url === '/resources/fixtureReference'}
            button
            component={Link}
            to='/resources/fixtureReference'
            disableGutters
            disabled={!isUserAuthorized('FIXTURE')}
          >
            <MyTypography>{t_('Fixture')}</MyTypography>
          </ListItemNested>

          <ListItemNested
            selected={url === '/resources/toolManager'}
            button
            component={Link}
            to='/resources/toolManager'
            disableGutters
            disabled={!isUserAuthorized('TOOLS')}
          >
            <MyTypography>{t_('Tools')}</MyTypography>
          </ListItemNested>

          <ListItemNested
            selected={url === '/resources/bomLibrary'}
            button
            component={Link}
            to='/resources/bomLibrary'
            disableGutters
            disabled={!isUserAuthorized('BOM_LIBRARY')}
          >
            <MyTypography>{t_('BOM')}</MyTypography>
          </ListItemNested>
        </Collapse>

        <ListItemMain
          selected={url === '/dataAnalytics'}
          button
          onClick={() => setOpenDataAnalytics(!openDataAnalytics)}
          disableGutters
          disabled={!isUserAuthorized('ANALYTICS')}
        >
          <DataUsageRounded sx={iconsShadowStyle} />
          <MyTypography>
            {t_('ANALYTICS')}
          </MyTypography>
          {openDataAnalytics ? <ArrowDropUp /> : <ArrowDropDown />}
        </ListItemMain>

        <Collapse in={openDataAnalytics} timeout='auto' unmountOnExit>
          <ListItemNested
            selected={url === '/dataAnalytics/dashboard'}
            button
            onClick={() => setOpenDashboard(!openDashboard)}
            disableGutters
            disabled={!isUserAuthorized('DASHBOARD')}
          >
            <MyTypography>{t_('Dashboard')}</MyTypography>
            {openReport ? <ArrowDropUp /> : <ArrowDropDown />}
          </ListItemNested>
          <Collapse in={openDashboard} timeout='auto' unmountOnExit>
            <ListItemNested2
              selected={url === '/dataAnalytics/dashboard/oee'}
              button
              component={Link}
              to='/dataAnalytics/dashboard/oee'
              disableGutters
              disabled={!isUserAuthorized('DASHBOARD_OEE')}
            >
              <MyTypography>{t_('OEE')}</MyTypography>
            </ListItemNested2>
            <ListItemNested2
              selected={url === '/dataAnalytics/dashboard/production'}
              button
              component={Link}
              to='/dataAnalytics/dashboard/production'
              disableGutters
              disabled={!isUserAuthorized('DASHBOARD_PRODUCTION')}
            >
              <MyTypography>{t_('Production')}</MyTypography>
            </ListItemNested2>
            <ListItemNested2
              selected={url === '/dataAnalytics/dashboard/planning'}
              button
              component={Link}
              to='/dataAnalytics/dashboard/planning'
              disableGutters
              disabled={!isUserAuthorized('DASHBOARD_PLANNING')}
            >
              <MyTypography>{t_('Planning')}</MyTypography>
            </ListItemNested2>
            <ListItemNested2
              selected={url === '/dataAnalytics/dashboard/tooling'}
              button
              component={Link}
              to='/dataAnalytics/dashboard/tooling'
              disableGutters
              disabled={!isUserAuthorized('DASHBOARD_TOOLING')}
            >
              <MyTypography>{t_('Tooling')}</MyTypography>
            </ListItemNested2>
            <ListItemNested2
              selected={url === '/dataAnalytics/dashboard/customized'}
              button
              component={Link}
              to='/dataAnalytics/dashboard/customized'
              disableGutters
              disabled={!isUserAuthorized('DASHBOARD_CUSTOMIZED')}
            >
              <MyTypography>{t_('Customized')}</MyTypography>
            </ListItemNested2>
            {proxiedServiceItems.map((service) => (
              <ListItemNested2
                key={service.prefix}
                selected={url === '/dataAnalytics/dashboard/proxied/' + service.prefix}
                button
                component={Link}
                to={'/dataAnalytics/dashboard/proxied/' + service.prefix}
                disableGutters
              >
                <MyTypography>{service.name}</MyTypography>
              </ListItemNested2>
            ))}
          </Collapse>
          <ListItemDisable
            selected={url === '/dataAnalytics/prediction'}
            button
            component={Link}
            to='/dataAnalytics/prediction'
            disableGutters
            disabled={!isUserAuthorized('PREDICTION')}
          >
            <MyTypography>{t_('Prediction')}</MyTypography>
          </ListItemDisable>

          <ListItemNested
            selected={url === '/dataAnalytics/reports'}
            button
            onClick={() => setOpenReport(!openReport)}
            disableGutters
            disabled={!isUserAuthorized('REPORTS')}
          >
            <MyTypography>{t_('Reports')}</MyTypography>
            {openReport ? <ArrowDropUp /> : <ArrowDropDown />}
          </ListItemNested>

          <Collapse in={openReport} timeout='auto' unmountOnExit>
            <ListItemNested2
              selected={url === '/dataAnalytics/reports/preset'}
              button
              component={Link}
              to='/dataAnalytics/reports/preset'
              disableGutters
              disabled={!isUserAuthorized('PRESET')}
            >
              <MyTypography>{t_('Preset')}</MyTypography>
            </ListItemNested2>

            <ListItemNested2
              selected={
                url === '/dataAnalytics/reports/inspection'
              }
              button
              component={Link}
              to='/dataAnalytics/reports/inspection'
              disableGutters
              disabled={!isUserAuthorized('INSPECTION')}
            >
              <MyTypography>
                {t_('Inspection')}
              </MyTypography>
            </ListItemNested2>
            <ListItemNested2
              selected={
                url === '/dataAnalytics/reports/qualityReport'
              }
              button
              component={Link}
              to='/dataAnalytics/reports/qualityReport'
              disableGutters
              disabled={!isUserAuthorized('QUALITY')}
            >
              <MyTypography>
                {t_('Quality')}
              </MyTypography>
            </ListItemNested2>
          </Collapse>
        </Collapse>

        <ListItemMain
          selected={url === '/configuration'}
          button
          onClick={() => setOpenConfiguration(!openConfiguration)}
          disableGutters
          disabled={!isUserAuthorized('CONFIGURATION')}
        >
          <SettingsRounded sx={iconsShadowStyle} />
          <MyTypography>
            {t_('CONFIGURATION')}
          </MyTypography>
          {openConfiguration ? <ArrowDropUp /> : <ArrowDropDown />}
        </ListItemMain>
        <Collapse in={openConfiguration} timeout='auto' unmountOnExit>
          <ListItemNested
            selected={url === '/configuration/assets'}
            button
            component={Link}
            to='/configuration/assets'
            disableGutters
            disabled={!isUserAuthorized('ASSETS')}
          >
            <MyTypography>{t_('Assets')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/fixtureTypes'}
            button
            component={Link}
            to='/configuration/fixtureTypes'
            disableGutters
            disabled={!isUserAuthorized('FIXTURE TYPES')}
          >
            <MyTypography>{t_('Fixture Types')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/sensorsActuators'}
            button
            component={Link}
            to='/configuration/sensorsActuators'
            disableGutters
            disabled={!isUserAuthorized('SENSORS & ACTUATORS')}
          >
            <MyTypography>
              {t_('Sensors & Actuators')}
            </MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/technology'}
            button
            component={Link}
            to='/configuration/technology'
            disableGutters
            disabled={!isUserAuthorized('TECHNOLOGY')}
          >
            <MyTypography>{t_('Technology')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/toolGroups'}
            button
            component={Link}
            to='/configuration/toolGroups'
            disableGutters
            disabled={!isUserAuthorized('TOOLS_MANAGER')}
          >
            <MyTypography>{t_('Tools manager')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/calendars'}
            button
            component={Link}
            to='/configuration/calendars'
            disableGutters
            disabled={!isUserAuthorized('CALENDARS')}
          >
            <MyTypography>{t_('Calendars')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/features'}
            button
            component={Link}
            to='/configuration/features'
            disableGutters
            disabled
          >
            <MyTypography>{t_('Features')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/picklist'}
            button
            component={Link}
            to='/configuration/picklist'
            disableGutters
            disabled={!isUserAuthorized('PICKLIST')}
          >
            <MyTypography>{t_('Picklist')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/customer'}
            button
            component={Link}
            to='/configuration/customer'
            disableGutters
            disabled={!isUserAuthorized('CLIENT')}
          >
            <MyTypography>{t_('Customers')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/workers'}
            button
            component={Link}
            to='/configuration/workers'
            disableGutters
            disabled={!isUserAuthorized('WORKERS')}
          >
            <MyTypography>{t_('Workers')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/materials'}
            button
            component={Link}
            to='/configuration/materials'
            disableGutters
            disabled={!isUserAuthorized('MATERIALS')}
          >
            <MyTypography>{t_('Materials')}</MyTypography>
          </ListItemNested>
          <ListItemNested
            selected={url === '/configuration/printers'}
            button
            component={Link}
            to='/configuration/printers'
            disableGutters
            disabled={!isUserAuthorized('GENERATE_QR_CODE')}
          >
            <MyTypography>{t_('Printers')}</MyTypography>
          </ListItemNested>
          {/* S152 (historia 170, HU-05, CRÍTICO) — DI-7 exception: unlike every other entry of this
              Collapse (disabled, never hidden), this one is OMITTED entirely without
              DOCUMENT_REPOSITORY, so a profile without the module permission never learns it exists. */}
          {isUserAuthorized('DOCUMENT_REPOSITORY') && (
            <ListItemNested
              selected={url === '/configuration/documentRepository'}
              button
              component={Link}
              to='/configuration/documentRepository'
              disableGutters
            >
              <MyTypography>{t_('Document repository')}</MyTypography>
            </ListItemNested>
          )}
        </Collapse>
        <ListItemMain
          selected={url === '/maintenance'}
          onClick={() => setOpenMaintenance(!openMaintenance)}
          button
          disableGutters
          // Story 213 (S118, B-R3-4): SETTINGS alone opens the group too, to reach Vision incidents.
          disabled={!isUserAuthorized('MAINTENANCE') && !isUserAuthorized('SETTINGS')}
        >
          <BuildRounded sx={iconsShadowStyle} />
          <MyTypography>{t_('MAINTENANCE')}</MyTypography>
          {openMaintenance ? <ArrowDropUp /> : <ArrowDropDown />}
        </ListItemMain>
        <Collapse in={openMaintenance} timeout='auto' unmountOnExit>
          <ListItemNested
            selected={url === '/maintenance/alarms'}
            button
            component={Link}
            to='/maintenance/alarms'
            disableGutters
            disabled={!isUserAuthorized('ALARMS')}
          >
            <MyTypography>{t_('Alarms')}</MyTypography>
          </ListItemNested>
          {/* Story 213 (S118, DP-12) — next to Alarms and, like Document repository, OMITTED without
              SETTINGS rather than disabled (PO, 2026-10-20: the vision permissions are gone). */}
          {isUserAuthorized('SETTINGS') && (
            <ListItemNested
              selected={url === '/maintenance/visionIncidents'}
              button
              component={Link}
              to='/maintenance/visionIncidents'
              disableGutters
            >
              <MyTypography>{t_('Vision incidents')}</MyTypography>
            </ListItemNested>
          )}
          <ListItemNested
            selected={url === '/maintenance/notifications'}
            button
            component={Link}
            to='/maintenance/notifications'
            disableGutters
            disabled={!isUserAuthorized('NOTIFICATIONS')}
          >
            <MyTypography>{t_('Notifications')}</MyTypography>
          </ListItemNested>

          {staticConfig && staticConfig.cell === 'CELL007 - SMARTPM'
            ? (
              <ListItem
                selected={url === '/maintenance/presenceDetection'}
                button
                component={Link}
                to='/maintenance/presenceDetection'
                disableGutters
              >
                <MyTypography>{t_('Presence Detection')}</MyTypography>
              </ListItem>)
            : (null)}
        </Collapse>
        {/* RN1/RN5 — Quality becomes a dropdown only when Product Acceptance (MOD) is actually
            reachable for THIS user: client flag active AND FABRICATION_ORDER_ACCEPTANCE permission
            (S1). Without the permission the sub-option is not rendered (S3); on non-GDELS
            installations (flag off) Quality keeps its original single-link behaviour, unchanged. */}
        {acceptanceEnabled && isUserAuthorized('FABRICATION_ORDER_ACCEPTANCE')
          ? (
            <>
              <ListItemMain
                selected={url === '/quality' || url === '/quality/productAcceptance'}
                button
                disableGutters
                onClick={() => setOpenQuality(!openQuality)}
              >
                <SavedSearchRounded sx={iconsShadowStyle} />
                <MyTypography>{t_('QUALITY')}</MyTypography>
                {openQuality ? <ArrowDropUp /> : <ArrowDropDown />}
              </ListItemMain>
              <Collapse in={openQuality} timeout='auto' unmountOnExit>
                <ListItemNested
                  selected={url === '/quality'}
                  button
                  component={Link}
                  to='/quality'
                  disableGutters
                  disabled={!isUserAuthorized('QUALITY')}
                >
                  <MyTypography>{t_('Quality')}</MyTypography>
                </ListItemNested>
                <ListItemNested
                  selected={url === '/quality/productAcceptance'}
                  button
                  component={Link}
                  to='/quality/productAcceptance'
                  disableGutters
                >
                  <MyTypography>{t_('Product Acceptance (MOD)')}</MyTypography>
                </ListItemNested>
              </Collapse>
            </>)
          : (
            <ListItemMain
              selected={url === '/quality'}
              button
              component={Link}
              to='/quality'
              disableGutters
              disabled={!isUserAuthorized('QUALITY')}
            >
              <SavedSearchRounded sx={iconsShadowStyle} />
              <MyTypography>{t_('QUALITY')}</MyTypography>
            </ListItemMain>)}

        <ListItemMain
          button
          onClick={handleMosClick}
          disabled={licensedModules.length === 0}
        >
          <NearMeIcon sx={iconsShadowStyle} />
          <MyTypography>{t_('MOS')}</MyTypography>

          {licensedModules.length > 1 && (
            openMos ? <ArrowDropUp /> : <ArrowDropDown />
          )}
        </ListItemMain>
        {licensedModules.length > 1 && (
          <Collapse in={openMos} timeout='auto' unmountOnExit>
            {isUserAuthorized('RECEPTION') && (
              <ListItemNested
                selected={url === '/mos/reception'}
                button
                component={Link}
                to='/mos/reception'
              >
                <MyTypography>{t_('Reception')}</MyTypography>
              </ListItemNested>
            )}
            {isUserAuthorized('MANUFACTURING') && (
              <ListItemNested
                selected={url === '/mos/manufacturing'}
                button
                onClick={() => setHideMenu(true)}
                component={Link}
                to='/mos/manufacturing'
              >
                <MyTypography>{t_('Manufacturing')}</MyTypography>
              </ListItemNested>
            )}
            {isUserAuthorized('DATA_CORRECTION_VIEW') && (
              <ListItemNested
                selected={url === '/mos/dataCorrection'}
                button
                component={Link}
                to='/mos/dataCorrection'
              >
                <MyTypography>{t_('Workday correction')}</MyTypography>
              </ListItemNested>
            )}
            {/* {isUserAuthorized('ASSEMBLY') && (
              <ListItemNested
                selected={url === '/mos/assembly'}
                button
                component={Link}
                to='/mos/assembly'
              >
                <MyTypography>{t_('Assembly')}</MyTypography>
              </ListItemNested>
            ) */}
          </Collapse>
        )}
      </List>
      <Divider />
      <List>
        {minimizeDrawer
          ? (
            <ListItem button onClick={handleMinimizeDrawer}>
              <ListItemIcon>
                <ArrowForward />
              </ListItemIcon>
              <ListItemText primary={t_('Close')} />
            </ListItem>
            )
          : (
            <ListItem
              onClick={() => handleMinimizeDrawer() & handleCloseAllMenus()}
              button
            >
              <ListItemIcon>
                <ArrowBack />
              </ListItemIcon>

              <ListItemText primary={t_('Close')} />
            </ListItem>
            )}
      </List>

    </div>
  )
}
